<template>
  <div :id="pageId" :class="pageClass">
    <div class="debug-mode-active" v-if="this.debugMode === true">
      DEBUG MODE
    </div>
    <transition name="fade" mode="out-in" v-on:leave="applyPageClasses">
      <component
        :key="pageConfig.key"
        :is="pageComponent"
        :index="index"
        :config="pageConfig"
      ></component>
    </transition>
  </div>
</template>

<script>
import SplashPage from "@/components/Splash";
import SurveyPage from "@/components/Survey";
import ResultPage from "@/components/Result";
import ContentPage from "@/components/ContentPage";
import CustomContent from "@/components/CustomContent";
import { mapState } from "vuex";
import Helpers from "../lib/Helpers";
export default {
  data() {
    return {
      pageComponent: null,
      pageConfig: {},
      pageId: "",
      pageClass: ""
    };
  },
  mixins: [Helpers],
  inject: ["convince"],
  computed: mapState(["index"]),
  components: {
    SplashPage,
    SurveyPage,
    ResultPage,
    ContentPage,
    CustomContent
  },
  methods: {
    applyPageClasses(el, done) {
      setTimeout(() => {
        this.pageId = this.cssId(this.pageConfig);
        this.pageClass = [
          this.cssClass("page", this.pageConfig),
          "page-wrapper"
        ];
        done();
      }, 500);
    },
    update: function() {
      this.config = window.cogniclick.config;
      this.$store.commit("setIndex", this.$route.params.id || 0);
      this.$store.commit("setRoute", this.$route.name);
      const translations =
        typeof this.config.translations !== "undefined"
          ? this.config.translations
          : {};
      const supportedLanguages =
        typeof this.config.supportedLanguages !== "undefined"
          ? this.config.supportedLanguages
          : ["EN"];

      // this.$route.name and $this.route.params.hash
      const uuid = this.$route.params.responseUuid;
      if (this.$route.name === "result" && uuid) {
        this.convince.response(uuid).then((resp) => {
          this.$store.commit("setAnswers", resp.data.data);
          this.$store.commit("setLanguage", resp.data.data.language);
          this.$store.commit("setLanguages", {
            translations: translations,
            supported: supportedLanguages
          });
          this.$store.commit("setSession", resp.data.session);
          this.$store.commit("setStatus", resp.data.status);
          this.$store.commit("signup", resp.data.signup);
          this.$store.commit("setResponseUUID", uuid);
          this.$store.commit("setResultURL", resp.data.url);
          this.$store.commit("setScores", resp.data.scores.answers);
          this.convince.config = resp.data.session;
          const resultIndex = this.$store.getters.lastPageIndex;
          this.pageConfig = this.config.pages[resultIndex];
          this.pageComponent = this.pageConfig.type;
        });
      } else {
        if (typeof this.config.pages[this.index] === "undefined") {
          return this.$router.replace("/not_found");
        } else {
          this.pageConfig = this.config.pages[this.index];
          this.pageComponent = this.pageConfig.type;
          if (
            typeof this.pageConfig.finalise !== "undefined" &&
            this.pageConfig.finalise === true
          ) {
            this.$store.dispatch("finalise");
          }
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      this.update();
    }
  },
  created() {
    this.update();
  }
};
</script>

<style lang="scss">
.page {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
